import { api } from "./api";

export const dashboardApi = (params) => {
    return api.get(`/dashboard`, { params });
};

export const dashboardMonthlySalesApi = (params) => {
    return api.get(`/dashboard/monthly-sales`, { params });
};

export const dashboardOutOfStockProductsApi = (params) => {
    return api.get(`/dashboard/out-of-stock/products`, { params });
};

export const dashboardLowStockProductsApi = (params) => {
    return api.get(`/dashboard/low-stock/products`, { params });
};